/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './MobileStatementsFilters.scss';

import { bool, func, object } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  selectStatementsDocumentTypes,
  selectStatementsTimePeriod,
  selectStatementsProductTypes
} from 'state/statements/StatementsActions';
import {
  priorYear,
  currentYear,
  mapStatementsProductName
} from 'services/Statements';
import { getNonViewOnlyProducts } from 'state/account/AccountSelectors';
import {
  ALL_DOCUMENT_TYPES,
  getNonViewOnlyProductTypeOptions,
  STATEMENTS_DOC_SELECTION
} from 'state/statements/StatementsSelectors';
import BaseModal from 'components/shared/Modal/BaseModal';
import MobileTimePeriodSelect from 'components/shared/PeriodSelector/MobileTimePeriodSelect';
import MobileRadioList from 'components/shared/Radio/MobileRadioList';
import Store from 'state/Store';

const selectTimePeriod = (value) => {
  Store.dispatch(selectStatementsTimePeriod(value.toString()));
};

const selectDocumentTypes = (value) => {
  Store.dispatch(selectStatementsDocumentTypes(value));
};

const selectProductTypes = (value) => {
  Store.dispatch(selectStatementsProductTypes(value));
};

const showProductFilters = (
  statementsFilteringSelections,
  nonViewOnlyProducts
) => {
  const { documentTypes } = statementsFilteringSelections;
  return (
    documentTypes.selection !== ALL_DOCUMENT_TYPES &&
    documentTypes.selection !== STATEMENTS_DOC_SELECTION &&
    nonViewOnlyProducts.length > 1
  );
};

const shouldResetProductType = (prevProps, statementsFilteringSelections) => {
  const { documentTypes } = statementsFilteringSelections;
  return (
    prevProps.statementsFilteringSelections.documentTypes.selection !==
      documentTypes.selection &&
    documentTypes.selection !== STATEMENTS_DOC_SELECTION &&
    documentTypes.selection !== ALL_DOCUMENT_TYPES
  );
};

class MobileStatementsFilters extends React.Component {
  componentDidMount() {
    const {
      query: {
        params: { documentFilter, year }
      },
      statementsFilteringSelections,
      nonViewOnlyProducts
    } = this.props;
    const { documentTypes } = statementsFilteringSelections;
    if (
      documentFilter &&
      documentTypes.options.find((o) => o.value === documentFilter)
    ) {
      if (year && year === 'prior') {
        Store.dispatch(selectStatementsTimePeriod(priorYear.toString()));
      } else {
        //Default to current year if year is not supplied in the URL because 2 out of the 3 doc types are mainly relevant for current year
        Store.dispatch(selectStatementsTimePeriod(currentYear.toString()));
      }
      Store.dispatch(selectStatementsDocumentTypes(documentFilter));
    }
    if (nonViewOnlyProducts.length === 1) {
      const productType = mapStatementsProductName(nonViewOnlyProducts);
      Store.dispatch(selectStatementsProductTypes(productType));
    }
  }

  componentDidUpdate(prevProps) {
    const { nonViewOnlyProducts, statementsFilteringSelections } = this.props;
    const resetProductTypeRule = shouldResetProductType(
      prevProps,
      statementsFilteringSelections
    );
    if (
      prevProps.nonViewOnlyProducts !== nonViewOnlyProducts ||
      resetProductTypeRule
    ) {
      if (nonViewOnlyProducts.length === 1) {
        const productType = mapStatementsProductName(nonViewOnlyProducts);
        Store.dispatch(selectStatementsProductTypes(productType));
      }
    }
  }

  render() {
    const {
      statementsFilteringSelections,
      productsOptions,
      close,
      isOpen,
      nonViewOnlyProducts
    } = this.props;
    const { documentTypes, timePeriod, productTypes } =
      statementsFilteringSelections;
    const showProductFilter = showProductFilters(
      statementsFilteringSelections,
      nonViewOnlyProducts
    );
    return (
      <BaseModal close={close} isOpen={isOpen} title="Filters" hideAnchor>
        <div className="mobile-statements-filter-group">
          <MobileTimePeriodSelect
            options={timePeriod.options}
            selection={timePeriod.selection}
            className="mobile-statements-filter-radio-container"
            onChange={selectTimePeriod}
          />

          <MobileRadioList
            label="Document Types"
            options={documentTypes.options}
            selection={documentTypes.selection}
            className="mobile-statements-filter-radio-container"
            onChange={selectDocumentTypes}
          />

          {showProductFilter && (
            <MobileRadioList
              label="Product Types"
              onChange={selectProductTypes}
              options={productsOptions}
              className="mobile-statements-filter-radio-container"
              selection={productTypes.selection}
            />
          )}
        </div>
      </BaseModal>
    );
  }
}

const mapStateToProps = (state) => ({
  query: state.session.query,
  statementsFilteringSelections: state.statementsFilteringSelections,
  productsOptions: getNonViewOnlyProductTypeOptions(state),
  nonViewOnlyProducts: getNonViewOnlyProducts(state)
});

MobileStatementsFilters.propTypes = {
  close: func.isRequired,
  isOpen: bool.isRequired,
  statementsFilteringSelections: object.isRequired
};

export default withRouter(connect(mapStateToProps)(MobileStatementsFilters));
